export default "__VITE_ASSET__Hb2lMHS7__"